var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "fixed inset-0 z-30" }, [
    _c(
      "div",
      {
        staticClass: "w-full h-full bg-paint",
        class: { "pt-smh": _vm.$root.siteMessageIsVisible },
      },
      [
        _c("div", { staticClass: "w-full h-full pt-shh" }, [
          _c(
            "div",
            { staticClass: "w-full h-full overflow-y-auto scrolling-touch" },
            [_vm._t("default")],
            2
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }